define(['../services/settings', 'jquery'], function () {
    'use strict';

    return {
        name: 'settingsCtrl',
        arguments: [
            '$interval',
            '$rootScope',
            '$scope',
            '$timeout',
            'ErrorHandler',
            'FileUpload',
            'Settings',
            'Profile',
            'Site',
            function (
                $interval,
                $rootScope,
                $scope,
                $timeout,
                ErrorHandler,
                FileUpload,
                Settings,
                Profile,
                Site
            ) {
                $scope.editSettings = {};
                $scope.user = Profile.getProfile();
                $scope.settings = Settings.getSettings(false, function (data) {
                    $scope.editSettings = $.extend(true, {}, data);

                    if (
                        $scope.startWithCity &&
                        $scope.editSettings.dynamicCities.length <= 0
                    ) {
                        $scope.editSettings.addDynamicCity();
                    }
                });
                $scope.editSite = {};
                $scope.site = Site.getSite(false, function (data) {
                    $scope.editSite = $.extend(true, {}, data);
                });
                $scope.$watch('site.domain', () => {
                    $scope.domainResults = Profile.checkDomain($scope.site.domain);
                });

                $scope.deleteCurrentSite = function () {
                    if ($scope.site) {
                        $scope.site.delete(function () {
                            window.location = $rootScope.Routing.generate(
                                'index'
                            );
                        });
                    }
                };

                // Avatar upload
                $scope.onFileSelect = function (
                    $event,
                    $files,
                    owner_id,
                    property
                ) {
                    $scope.uploadErrors = [];
                    angular.forEach($files, function (file) {
                        if (file.name.endsWith('.jfif')) {
                            // Explicitly deny .jfif file uploads because they reportedly don't work in Facebook ads
                            $scope.uploadErrors = [
                                '.jfif files are not supported.  Please upload your image in a different format.',
                            ];
                        } else {
                            FileUpload.uploadImage(
                                file,
                                owner_id,
                                'AppSiteBundle:Settings',
                                '',
                                property
                            )
                                .then(function () {
                                    $scope.settings = Settings.getSettings(
                                        true
                                    );
                                    $scope.uploadErrors = '';
                                })
                                .catch(function (result) {
                                    $scope.uploadErrors = ErrorHandler.getMessage(
                                        result,
                                        'Your image failed to upload.  Please try again.'
                                    );
                                });
                        }
                    });
                    $event.target.value = '';
                };
                $scope.onCityImage = function ($event, $files, owner) {
                    owner.uploadErrors = '';
                    angular.forEach($files, function (file) {
                        if (file.name.endsWith('.jfif')) {
                            // Explicitly deny .jfif file uploads because they reportedly don't work in Facebook ads
                            owner.uploadErrors = [
                                '.jfif files are not supported.  Please upload your image in a different format.',
                            ];
                        } else {
                            FileUpload.uploadImage(
                                file,
                                owner.id,
                                'AppSiteBundle:DynamicCity',
                                'city_thumbnail'
                            )
                                .then(function (url) {
                                    url = url.data;
                                    if (
                                        !owner.hasOwnProperty('backgroundImage')
                                    ) {
                                        owner.backgroundImage = {
                                            urls: {
                                                city_thumbnail: '',
                                            },
                                        };
                                    }
                                    owner.backgroundImage.urls.city_thumbnail = url;
                                    owner.uploadErrors = '';
                                })
                                .catch(function (result) {
                                    owner.uploadErrors = ErrorHandler.getMessage(
                                        result,
                                        'Your image failed to upload.  Please try again.'
                                    );
                                });
                        }
                    });
                    $event.target.value = '';
                };
                // END Avatar upload

                // Embed form
                $scope.embedCode = '';
                $scope.user.$promise.then(function (user) {
                    $scope.embedCode =
                        '<div id="hvl-embed"></div>\n<script type="text/javascript" src="//' +
                        window.location.hostname +
                        Routing.generate('embed_form_agent', {
                            site: $scope.site.id,
                            _format: 'js',
                        }) +
                        '">\n</script>';
                });

                // variable to prevent sending a bunch of requests for rapid changes
                var savingSettingsTimeout = false;
                $scope.saveSettings = function (
                    settingsForm,
                    includePropertyTypes,
                    includeDynamicCities
                ) {
                    settingsForm.submitted = true;

                    if (settingsForm.$valid) {
                        if (savingSettingsTimeout) {
                            $timeout.cancel(savingSettingsTimeout);
                        }

                        savingSettingsTimeout = $timeout(function () {
                            var savingInterval = $interval(function () {
                                if (!settingsForm.working) {
                                    $interval.cancel(savingInterval);
                                    savingSettingsTimeout = false;
                                    settingsForm.working = true;

                                    var success = true;
                                    /* Transfer relevant properties from editSettings to settings
                                     * so we're only saving the changes from the submitted section
                                     */
                                    var newOptions = {};
                                    if (includePropertyTypes) {
                                        $scope.settings.propertyTypes = $.extend(
                                            true,
                                            {},
                                            $scope.editSettings.propertyTypes
                                        );
                                    }
                                    if (includeDynamicCities) {
                                        $scope.settings.dynamicCities = $.extend(
                                            true,
                                            {},
                                            $scope.editSettings.dynamicCities
                                        );
                                    } else {
                                        // Don't send dynamic cities to avoid hidden validation errors
                                        delete $scope.settings.dynamicCities;
                                    }
                                    angular.forEach(settingsForm, function (
                                        val,
                                        key
                                    ) {
                                        if (key.indexOf('$') != 0) {
                                            // Ignore internal angular attributes that start with $
                                            newOptions[key] =
                                                $scope.editSettings.options[
                                                    key
                                                ];
                                        }
                                    });
                                    $.extend(
                                        true,
                                        $scope.settings.options,
                                        newOptions
                                    );
                                    $scope.settings
                                        .save()
                                        .catch(function (result) {
                                            /**
                                             * Reload settings object if the
                                             * save failed to make sure we're
                                             * not trying to save bad data over
                                             * and over.
                                             */
                                            $scope.settings = Settings.getSettings(
                                                true
                                            );
                                            if (settingsForm) {
                                                settingsForm.serverErrors = ErrorHandler.getMessage(
                                                    result,
                                                    'Error saving settings.  Please try again'
                                                );
                                            }
                                            success = false;
                                            settingsForm.working = false;
                                        })
                                        .then(function (result) {
                                            if (success) {
                                                $.extend(
                                                    true,
                                                    $scope.site,
                                                    $scope.editSite
                                                );
                                                $scope.site
                                                    .save()
                                                    .catch(function (result) {
                                                        if (settingsForm) {
                                                            settingsForm.serverErrors = ErrorHandler.getMessage(
                                                                result,
                                                                'Error saving settings.  Please try again'
                                                            );
                                                        }
                                                        success = false;
                                                        settingsForm.working = false;
                                                    })
                                                    .then(function (result) {
                                                        if (success) {
                                                            Site.getAllSites(
                                                                true
                                                            );
                                                            if (settingsForm) {
                                                                settingsForm.submitted = false;
                                                                settingsForm.serverErrors = null;
                                                            }
                                                            $scope.settingsUpdated =
                                                                settingsForm.$name;
                                                            $timeout(
                                                                function () {
                                                                    $scope.settingsUpdated = false;
                                                                },
                                                                5000
                                                            );
                                                            if (
                                                                !savingSettingsTimeout
                                                            ) {
                                                                // Reload saved settings into editSettings
                                                                Settings.getSettings(
                                                                    false,
                                                                    function (
                                                                        data
                                                                    ) {
                                                                        angular.extend(
                                                                            $scope
                                                                                .editSettings
                                                                                .options,
                                                                            data.options
                                                                        );
                                                                        angular.extend(
                                                                            $scope
                                                                                .editSettings
                                                                                .propertyTypes,
                                                                            data.propertyTypes
                                                                        );
                                                                        // Iterate through cities so form doesn't re-draw and lose focus
                                                                        for (
                                                                            var i = 0;
                                                                            i <
                                                                            data
                                                                                .dynamicCities
                                                                                .length;
                                                                            i++
                                                                        ) {
                                                                            angular.extend(
                                                                                $scope
                                                                                    .editSettings
                                                                                    .dynamicCities[
                                                                                    i
                                                                                ],
                                                                                data
                                                                                    .dynamicCities[
                                                                                    i
                                                                                ]
                                                                            );
                                                                        }
                                                                    }
                                                                );
                                                                // Update user in case settings effect its properties
                                                                var newUser = Profile.getProfile(
                                                                    true,
                                                                    function () {
                                                                        $scope.user = newUser;
                                                                        $rootScope.$broadcast(
                                                                            'user-updated'
                                                                        );
                                                                    }
                                                                );
                                                            }
                                                        }
                                                        settingsForm.working = false;
                                                    });
                                            }
                                        });
                                }
                            }, 100);
                        }, 500);
                    }
                };
                //Increase/Decrease selects on AVM page
                $scope.pm = {
                    adjust: function (newValue, field, incdec) {
                        //set
                        if (typeof newValue != 'undefined') {
                            if (incdec == 'Decrease' && newValue > 0) {
                                field = newValue * -1;
                            } else {
                                field = newValue;
                            }
                        }
                        //get
                        else {
                            if (field < 0) {
                                newValue = field * -1;
                                incdec = 'Decrease';
                            } else {
                                newValue = field;
                                incdec = 'Increase';
                            }
                        }
                        return [newValue, field, incdec];
                    },
                    adjustMenu: function (newValue, field) {
                        //set
                        if (typeof newValue != 'undefined') {
                            if (newValue == 'Increase' && field < 0) {
                                field = field * -1;
                            } else if (newValue == 'Decrease' && field > 0) {
                                field = field * -1;
                            }
                        }
                        return field;
                    },
                    priceAdjustment: function (newValue) {
                        var results = $scope.pm.adjust(
                            newValue,
                            $scope.editSettings.options.priceAdjustment,
                            $scope.editSettings.options.priceAdjustmentPM
                        );
                        $scope.editSettings.options.priceAdjustment =
                            results[1];
                        $scope.editSettings.options.priceAdjustmentPM =
                            results[2];
                        return results[0];
                    },
                    priceAdjustmentMenu: function (newValue) {
                        $scope.editSettings.options.priceAdjustment = $scope.pm.adjustMenu(
                            newValue,
                            $scope.editSettings.options.priceAdjustment
                        );
                        return $scope.editSettings.options.priceAdjustmentPM;
                    },
                    lowPriceAdjustment: function (newValue) {
                        var results = $scope.pm.adjust(
                            newValue,
                            $scope.editSettings.options.lowPriceAdjustment,
                            $scope.editSettings.options.lowPriceAdjustmentPM
                        );
                        $scope.editSettings.options.lowPriceAdjustment =
                            results[1];
                        $scope.editSettings.options.lowPriceAdjustmentPM =
                            results[2];
                        return results[0];
                    },
                    lowPriceAdjustmentMenu: function (newValue) {
                        $scope.editSettings.options.lowPriceAdjustment = $scope.pm.adjustMenu(
                            newValue,
                            $scope.editSettings.options.lowPriceAdjustment
                        );
                        return $scope.editSettings.options.lowPriceAdjustmentPM;
                    },
                    highPriceAdjustment: function (newValue) {
                        var results = $scope.pm.adjust(
                            newValue,
                            $scope.editSettings.options.highPriceAdjustment,
                            $scope.editSettings.options.highPriceAdjustmentPM
                        );
                        $scope.editSettings.options.highPriceAdjustment =
                            results[1];
                        $scope.editSettings.options.highPriceAdjustmentPM =
                            results[2];
                        return results[0];
                    },
                    highPriceAdjustmentMenu: function (newValue) {
                        $scope.editSettings.options.highPriceAdjustment = $scope.pm.adjustMenu(
                            newValue,
                            $scope.editSettings.options.highPriceAdjustment
                        );
                        return $scope.editSettings.options
                            .highPriceAdjustmentPM;
                    },
                };
            },
        ],
    };
});
